/**
=========================================================
* Material Dashboard 2 PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect, useMemo } from "react";

// react-router components
import { useNavigate } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @material-ui core components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDBadge from "components/MDBadge";

// Material Dashboard 2 PRO React example components
import NotificationItem from "examples/Items/NotificationItem";

// Custom styles for DashboardNavbar
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  // navbarDesktopMenu,
} from "examples/Navbars/DashboardNavbar/styles";

// Material Dashboard 2 PRO React context
import {
  useMaterialUIController,
  setMiniSidenav,
} from "context";
// import axios from "axios";
// import { URL_API } from "config";
import { Divider, ListItemButton, ListItemText, Typography } from "@mui/material";
import { Fragment } from "react";

import { useAuthContext } from "context/AuthContext";
// import { io } from "socket.io-client";
import { useSocketContext } from "context/SocketContext";

// const socket = io(URL_API);

function DashboardNavbar({ absolute, light, isMini }) {
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useMaterialUIController();
  const [openMenu, setOpenMenu] = useState(false);
  const [openNotifications, setOpenNotifications] = useState(false);
  const [sendMessages, setSendMessages] = useState([]);
  // const [count, setCount] = useState(1);

  const { miniSidenav, transparentNavbar, fixedNavbar, darkMode, } = controller;

  const navigate = useNavigate();

  const { logout, user } = useAuthContext();
  const { messages } = useSocketContext();

  useEffect(() => {
    if (user) {
      setSendMessages(messages);
      // (async () => {
      //   await getSendMessagesByUser(user.uuid).then((response) => {
      //     if (response) setCount(count + 1);
      //   });
      // })()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, messages]);

  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(false);
  const handleOpenNotifications = (event) => setOpenNotifications(event.currentTarget);
  const handleCloseNotifications = () => setOpenNotifications(false);

  // const getSendMessagesByUser = async (uuid) => {
  //   const response = await axios.get(URL_API + `/send-messages/unread/${uuid}`, {
  //     headers: {
  //       Authorization: `Bearer ${localStorage.getItem("Tag")}`,
  //     },
  //   });

  //   setSendMessages(response?.data);
  // }

  let memoNotifications;

  // useEffect(() => {
  //   socket.on("notification", (message) => {
  //     if (message.company_id === user.company_id) {
  //       setSendMessages([...sendMessages, message])

  //       setCount(count + 1)
  //     }
  //   });
  //   // eslint-disable-next-line
  // }, [sendMessages])


  // eslint-disable-next-line react-hooks/exhaustive-deps
  memoNotifications = useMemo(() => sendMessages.length, [messages])

  const renderNotifications = () => {
    return (
      <Menu
        anchorEl={openNotifications}
        anchorReference={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={Boolean(openNotifications)}
        onClose={handleCloseNotifications}
        sx={{ mt: 2 }}
      >
        {sendMessages?.length ? sendMessages.slice(-3).filter((message) => !message.visualized).map((message) => {
          const date = new Date(message.created_at);
          const hour = `${date.getHours()}:${date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()}`;

          return (
            <>
              <ListItemButton
                alignItems="flex-start"
                onClick={() => navigate("/admin/notificacoes")}
                sx={{
                  borderRadius: '8px',
                  alignItems: 'center',
                  cursor: 'pointer',
                }}
              >
                <ListItemText
                  primary={
                    <Typography
                      sx={{ display: 'inline', fontWeight: !message.visualized && 400 }}
                      component="span"
                      variant="body2"
                      color="text.primary"
                    >
                      {message?.message}
                    </Typography>
                  }
                  secondary={
                    <Fragment>
                      <Typography
                        sx={{ display: 'inline', fontSize: '12px' }}
                        component="span"
                        variant="body2"
                        color="text.primary"
                      >{`${date.toLocaleDateString('pt-BR')}, ${hour}`}</Typography>
                    </Fragment>
                  }
                />
              </ListItemButton>
              <Divider variant="inset" component="li" />
            </>
          )
        }) :
          <Typography
            sx={{ display: 'inline', cursor: 'pointer' }}
            component="span"
            variant="body2"
            color="text.primary"
            onClick={() => navigate("/admin/notificacoes")}
          >
            <IconButton onClick={() => navigate("/admin/notificacoes")}>
              <Icon>message</Icon>
            </IconButton>

            Sem notificações
          </Typography>
        }
      </Menu>
    )
  };

  // Render the notifications menu
  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
    >
      <h4 className="text-overflow m-0">{user?.name}</h4>
      <NotificationItem
        onClick={() => {
          navigate("/admin/perfil");
        }}
        icon={<Icon>person</Icon>}
        title="Perfil"
      />
      <NotificationItem
        onClick={logout}
        icon={<Icon>logout</Icon>}
        title="Sair"
      />
    </Menu>
  );

  // Styles for the navbar icons
  const iconsStyle = ({
    palette: { dark, white, text },
    functions: { rgba },
  }) => ({
    color: () => {
      let colorValue = light || darkMode ? white.main : dark.main;

      if (transparentNavbar && !light) colorValue = darkMode ? rgba(text.main, 0.6) : text.main;

      return colorValue;
    },
  });

  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      color="inherit"
      sx={(theme) => navbar(theme, { false: false, absolute, light, darkMode })}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        <MDBox
          color="inherit"
          mb={{ xs: 1, md: 0 }}
          sx={(theme) => navbarRow(theme, { isMini })}
        >
          <IconButton
            // sx={navbarDesktopMenu}
            onClick={handleMiniSidenav}
            size="small"
            disableRipple
          >
            <Icon fontSize="medium" sx={iconsStyle}>
              {miniSidenav ? "menu_open" : "menu"}
            </Icon>
          </IconButton>
        </MDBox>
        {isMini ? null : (
          <MDBox sx={(theme) => navbarRow(theme, { isMini })}>
            <MDBox color={light ? "white" : "inherit"} sx={{ marginRight: '1rem' }}>
              <IconButton
                style={{ verticalAlign: "top" }}
                size="small"
                disableRipple
                color="inherit"
                sx={navbarIconButton}
                aria-controls="notification-menu"
                aria-haspopup="true"
                variant="contained"
                onClick={handleOpenNotifications}
              >
                <MDBadge color="error" size="xs" circular badgeContent={memoNotifications}>
                  <Icon sx={iconsStyle}>notifications</Icon>
                </MDBadge>
              </IconButton>
              {renderNotifications()}
            </MDBox>

            <MDBox onClick={handleOpenMenu} color={light ? "white" : "inherit"}>
              <h5 style={{ cursor: "pointer" }}>{user?.name}</h5>
            </MDBox>
            <MDBox color={light ? "white" : "inherit"}>
              <IconButton
                style={{ verticalAlign: "top" }}
                size="small"
                disableRipple
                color="inherit"
                sx={navbarIconButton}
                aria-controls="notification-menu"
                aria-haspopup="true"
                variant="contained"
                onClick={handleOpenMenu}
              >
                <MDBadge color="error" size="xs" circular>
                  <Icon sx={iconsStyle}>account_circle</Icon>
                </MDBadge>
              </IconButton>
              {renderMenu()}
            </MDBox>
          </MDBox>
        )}
      </Toolbar>
    </AppBar>
  );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
